import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

const InternalLink = ({
  attributes,
  node,
  history,
}) => {
  const contentId = node.data.get('contentId');
  const label = node.data.get('label');

  const handleRedirect = useCallback(() => {
    if (contentId) {
      history.push(`/content/${contentId}`);
    }
  }, [history, contentId]);

  return (
    <div
      className="internalLink__container"
      {...attributes}
    >
      <span className="internalLink__link" onClick={handleRedirect}>{label}</span>
    </div>
  );
};

InternalLink.propTypes = {
  children: PropTypes.node,
  isSelected: PropTypes.bool,
  node: PropTypes.shape({
    data: PropTypes.shape({
      get: PropTypes.func,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  attributes: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default withRouter(InternalLink);
